import SegmentPage from "@/pages/segments/SegmentPage";

export default function CollegePage() {
  return (
    <SegmentPage
      testId="college-page"
      leadSegment="college"
      whitepaperLabel="Collegiate Performance Department Blueprint"
      eyebrow="For Collegiate Programs"
      headline={<>Build one performance department.</>}
      subhead={
        <>
          Connect coaches, athletic trainers, strength staff, and sports medicine into one intelligence platform. One athlete. One record. One intelligence layer.
        </>
      }
      tone="#F59E0B"
      focus={[
        "Department collaboration",
        "Athlete lifecycle",
        "Shared records",
        "Return-to-play",
        "Integrated monitoring",
      ]}
      outcomes={[
        { title: "Unified departments.", body: "Head coach, pitching, S&C, AT, and sports medicine all working from the same athlete profile — role-scoped, audit-logged." },
        { title: "Faster return-to-play decisions.", body: "Composite gates enforce return protocols automatically — no more \"looks OK, send it\" moments." },
        { title: "Better athlete development.", body: "Longitudinal fingerprint across every re-screen turns risk management into a recruitable movement story." },
        { title: "Connected performance data.", body: "FlightScope, TrackMan, VALD, ForceDecks, Catapult — all in one athlete timeline, correlated with movement and recovery signals." },
      ]}
    />
  );
}
